/**
 * Assets de tema (URLs de imágenes / logos).
 * Experience puede sobreescribirlos vía `theme.assets` en el bundle.
 * Paths `content/...` se resuelven a CDN; `assets/...` son locales de la app.
 */
export type ThemeAssets = {
    /** Logo Simfinix / marca (footer login, etc.). */
    LOGO_URL: string;
    /** Imagen de fondo del login (full-bleed). */
    LOGIN_BACKGROUND_URL: string;
};

export const DEFAULT_THEME_ASSETS: ThemeAssets = {
    LOGO_URL: 'assets/logos/simfinix/logo.ico',
    LOGIN_BACKGROUND_URL: 'assets/login-background-default.jpg',
};

/** CSS custom properties para assets (valores `url(...)` listos para background-image). */
export const THEME_ASSET_CSS_VARS = {
    LOGO_URL: '--theme-logo-url',
    LOGIN_BACKGROUND_URL: '--login-background-image',
} as const satisfies Record<keyof ThemeAssets, string>;
